import { IActivatedPriceListData } from "common/records/ActivatedPriceList";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const RECEIVE_ACTIVATED_PRICE_LIST = "@activatedpricelist/RECEIVE_ACTIVATED_PRICE_LIST";
export const RECEIVE_ACTIVATED_PRICE_LISTS = "@activatedpricelist/RECEIVE_ACTIVATED_PRICE_LISTS";

export const ActivatedPriceListActions = {
  receiveActivatedPriceList: (activatedPriceList: IActivatedPriceListData, pushToList?: boolean) =>
    createAction(RECEIVE_ACTIVATED_PRICE_LIST, { activatedPriceList, pushToList }),

  receiveActivatedPriceLists: (activatedPriceLists: IActivatedPriceListData[]) =>
    createAction(RECEIVE_ACTIVATED_PRICE_LISTS, { activatedPriceLists }),
};

export type ActivatedPriceListActions = ActionsUnion<typeof ActivatedPriceListActions>;
